(function () {
    'use strict';

    angular
        .module('app')
        .controller('myNewsdeskController', myNewsdeskController);

    myNewsdeskController.$inject = ['$scope', 'myNewsdeskService'];
    function myNewsdeskController($scope, myNewsdeskService) {

        /* jshint validthis:true */
        var vm = this;

        vm.pressReleases = [];
        vm.defaultImageUrl = [];
        vm.init = init;
        vm.newsItem = null;
        vm.getPressRelease = getPressRelease;

        function init(defaultImageUrl) {
			vm.defaultImageUrl = defaultImageUrl;
		}

        function getPressReleases() {
        	myNewsdeskService.getPressReleases().then(
                    function (result) {
                    	vm.pressReleases = result.data.items.item;
                    },
                    function (reason) {
                    },
                    function (error) {
                        Console.log(error);
                    }
                );
        }
        getPressReleases();

        function getPressRelease(id) {
	        myNewsdeskService.getPressRelease(id).then(
                function (result) {
	                if (result.data !== null) {
                        vm.newsItem = result.data;
                    }
                },
				function (reason) {
				},
				function (error) {
					Console.log(error);
				}
			);
        }
    }
})();

